import React from 'react';

export default React.memo(function TextArea({ className = '', ...props }) {
  return (
    <textarea {...props}
           className={`w-full rounded-2xl bg-white border border-[#D0D5DD] outline-none px-4 py-3 shadow-sm resize-none ${className}`} />
  );
})
